export default {"src":"/_next/static/media/badge-outline.17149917.svg","height":33,"width":30,"blurWidth":0,"blurHeight":0};